import { render, staticRenderFns } from "./rechargeConfig.vue?vue&type=template&id=404b07cc&scoped=true&"
import script from "./rechargeConfig.vue?vue&type=script&lang=js&"
export * from "./rechargeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b07cc",
  null
  
)

export default component.exports